import { Injectable } from '@angular/core';
import { toast } from 'ngx-sonner';

@Injectable({
  providedIn: 'root'
})
export class Toast {

  private defaultOptions = {
    duration: 10000,
    position: 'top-right',
    closeButton: false,
    visibleToasts: 1,

  };

  /** Generic toast with default options */
  show(message: string, options: any = {}) {
    const finalOptions = {
      ...this.defaultOptions,
      ...options // user overrides default
    };

    toast(message, finalOptions);
  }

  /** Success toast */
  success(message: string, options: any = {}) {
    const finalOptions = {
      ...this.defaultOptions,
      ...options // user overrides default
    };

    toast.success(message, finalOptions);
  }

  /** Error toast */
  error(message: string, options: any = {}) {
    const finalOptions = {
      ...this.defaultOptions,
      ...options // user overrides default
    };

    toast.error(message, finalOptions);
  }

  /** Warning toast */
  warning(message: string, options: any = {}) {
    const finalOptions = {
      ...this.defaultOptions,
      ...options // user overrides default
    };

    toast.warning(message, finalOptions);
  }

  /** Info toast */
  info(message: string, options: any = {}) {
    const finalOptions = {
      ...this.defaultOptions,
      ...options // user overrides default
    };

    toast.info(message, finalOptions);
  }

  /** Custom style toast */
  custom(message: string, options: any = {}) {
    toast(message, {
      ...this.defaultOptions,
      ...options,
      duration: options.duration || 3500
    });
  }


}
